@if (row.subRows.length === 0) {
  <ng-container *ngTemplateOutlet="rowTemplate; context: { $implicit: row, idx: currentIndex }"> </ng-container>
}

@if (row.subRows.length > 0) {
  <div class="employer-edit__row">
    <div class="employer-edit__label_wrap collapse" [class.font-weight-bold]="true">
      {{ row.title | translate }}
      <button (click)="handleShowCollapse()" class="collapse-btn" [class.collapsed]="showCollapse">{{
        (showCollapse ? "COMMON.HIDE_COLLAPSE" : "COMMON.SHOW_COLLAPSE") | translate
      }}</button>
    </div>
    <ng-container *ngTemplateOutlet="errors; context: { $implicit: row, idx: currentIndex }"> </ng-container>
    <div class="sub-row-dropdown-container" [class.active]="showCollapse">
      <div class="wrapper">
        @for (subRow of row.subRows; track subRow; let i = $index) {
          <ng-container *ngTemplateOutlet="rowTemplate; context: { $implicit: subRow, idx: i }"> </ng-container>
        }
      </div>
    </div>
  </div>
}

<ng-template #rowTemplate let-rowItem>
  <div class="employer-edit__row" [class.has-tooltip]="rowItem.inputType === singleRowInputTypes.NO_INPUT">
    <div class="employer-edit__label_wrap" [class.font-weight-bold]="rowItem.labelBold">
      {{ rowItem.title | translate }}
      @if (rowItem.subTitle) {
        <span class="subtitle">
          {{ rowItem.subTitle | translate }}
        </span>
      }
    </div>

    <div class="employer-edit__stage" id="{{ rowItem.taxCardKey }}">
      @if (rowItem.inputType === singleRowInputTypes.NO_INPUT) {
        <div class="no-input">
          <app-more-info-tooltip
            [message]="rowItem.tooltipMessage"
            [titleTooltip]="rowItem.tooltipTitle"
          ></app-more-info-tooltip>
        </div>
      }
      @if (rowItem.inputType === singleRowInputTypes.PRICE) {
        <app-form-input
          [errors]="rowItem.errors"
          [label]="rowItem.inputLabel"
          [isCurrency]="rowItem.inputType === singleRowInputTypes.PRICE"
          [placeholder]="rowItem.inputPlaceholder"
          [employerStage]="true"
          [isDisabled]="rowItem.inputIsDisabled()"
          [isEmployer]="true"
          [isEditableSummaryEmployer]="isEditableSummaryEmployer"
          [isVerification]="isVerification || isSummary"
          [(model)]="employer[rowItem.taxCardKey]"
          [addClassB2B]="isBusiness"
          [classB2B]="'card_' + currentIndex + '_eid_input_' + rowItem.taxCardKey"
          [attr.data-cy]="'input_' + rowItem.taxCardKey + '_' + currentIndex"
        >
        </app-form-input>
      }

      @if (rowItem.inputType === singleRowInputTypes.YEAR) {
        <div class="year-input">
          <input
            type="text"
            [(ngModel)]="employer[rowItem.taxCardKey]"
            placeholder="{{ rowItem.inputPlaceholder | translate }}"
          />
          <span>{{ "INPUT.YEAR_INPUT" | translate }}</span>
        </div>
      }

      @if (rowItem.inputType === singleRowInputTypes.DATE) {
        <div class="employer-edit__stage stage_row" id="ib_date_from">
          <div class="employer-edit__stage_col">
            <div class="month-input">
              <input
                type="text"
                [(ngModel)]="employer.pensionBenefitsPaymentsStart"
                placeholder="{{ 'INPUT.DEFAULT.MONTH' | translate }}"
                [mask]="'d0'"
                (blur)="onBlurMonth($event, 'pensionBenefitsPaymentsStart')"
              />
              <app-validator-error-message
                [epValidator]="epValidator"
                [index]="0"
                [fieldName]="'pensionBenefitsPaymentsStart'"
              >
              </app-validator-error-message>
            </div>
            @if (isVerification) {
              <app-single-field-edit
                [field]="codes.periodOfEmploymentLower"
                [activeField]="unlocked"
                (toggle)="toggleField($event)"
                [offset]="true"
                [employerEdit]="employerFieldEdit"
              >
              </app-single-field-edit>
            }
          </div>
          <div class="employer-edit__stage_sep"></div>
          <div class="employer-edit__stage_col">
            <div class="month-input">
              <input
                type="text"
                [(ngModel)]="employer.pensionBenefitsPaymentsEnd"
                placeholder="{{ 'INPUT.DEFAULT.MONTH' | translate }}"
                [mask]="'d0'"
                (blur)="onBlurMonth($event, 'pensionBenefitsPaymentsEnd')"
              />
              <app-validator-error-message
                [epValidator]="epValidator"
                [index]="0"
                [fieldName]="'pensionBenefitsPaymentsEnd'"
              >
              </app-validator-error-message>
            </div>
            @if (isVerification) {
              <app-single-field-edit
                [field]="codes.periodOfEmploymentUpper"
                [activeField]="unlocked"
                (toggle)="toggleField($event)"
                [offset]="true"
                [employerEdit]="employerFieldEdit"
              >
              </app-single-field-edit>
            }
          </div>
        </div>
      }

      @if (isVerification) {
        <app-single-field-edit
          [field]="codes[rowItem.taxCardKey]"
          [activeField]="unlocked"
          (toggle)="toggleField($event)"
          [toRight]="true"
          [employerEdit]="employerFieldEdit"
        >
        </app-single-field-edit>
      }
    </div>
    @if (isSummary) {
      <app-employer-field-summary
        [employers]="employers"
        [fieldName]="rowItem.inputSummaryLabel"
        [fieldSymbol]="codes[rowItem.taxCardKey]"
        [spouseId]="spouseId"
      >
      </app-employer-field-summary>
    }
  </div>
  <ng-container *ngTemplateOutlet="errors; context: { $implicit: rowItem, idx: currentIndex }"> </ng-container>
</ng-template>

<ng-template #errors let-rowItem>
  <div class="employer-edit__error_wrapper">
    @if (rowItem.errors && rowItem.errors.length) {
      <div class="employer-edit__error_bc">
        {{ rowItem.errors[0] }}
      </div>
    }
    <app-validator-error-message
      [epValidator]="epValidator"
      [employerStage]="true"
      [index]="currentIndex"
      [fieldName]="rowItem.taxCardKey"
    >
    </app-validator-error-message>
    @if (empWarningList[currentIndex]?.selectedKeysToArray(rowItem.validationWarningFieldNames); as warnings) {
      @if (warnings.length) {
        <div
          class="employer-edit__warrning_bc"
          [class.no_border]="
            (rowItem.errors && rowItem.errors.length) || findValidationByFieldName(rowItem.validationErrorFieldNames)
          "
        >
          @for (warning of warnings; track warning) {
            <div>
              {{ warning | translate }}
            </div>
          }
        </div>
      }
    }
  </div>
</ng-template>
